import axios from 'axios'
import { BUSCAR_PASSAGEIRO_POR_CPF } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarPassageiroPorCpf (cpf) {
  const url = `${URL}/passageiro/cpf/${cpf}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_PASSAGEIRO_POR_CPF,
        payload: response

      })
  );
}
